var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Repeater',{attrs:{"value":_vm.value || [],"control":{
    options: {
      repeaterOptions: {
        titleTemplate: 'Spacing bar',
        buttonName: 'Add new spacing bar'
      }
    }
  }},on:{"input":function($event){return _vm.updateSpaceBars($event)}},scopedSlots:_vm._u([{key:"default",fn:function({ value, index }){return [_c('ElementStudioSpacingBar',{attrs:{"value":value},on:{"input":function($event){return _vm.updateSpaceBar($event, index)}}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }